import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {Observable} from "rxjs";
import {catchError, tap} from "rxjs/operators";
import {ByaHttp} from "../../services/bya-http";
import {AuthService} from "../../../@bya/auth/services/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class IndexService extends ByaHttp {

    private baseApi:string = "api/test/";

    constructor(
        private http: HttpClient, 
        protected dialog: MatDialog,
        protected authService: AuthService) {
        super(dialog, authService);
    }

    public getSistema(): Observable<any> {
        return this.http.get<any>(this.baseUrl + this.baseApi + 'sistema')
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<any>('', null))
            );
    }
    
    
}
